import Channels from 'Chronos.Channels';

export default new Channels();



// WEBPACK FOOTER //
// ./src/lib/gChannel.js